import { AddressFields, ContactFields, FormActions } from '@common';
import { Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type AddCompanySiteFormFieldsPropsType = {
  onClose: () => void;
};

export const AddCompanySiteFormFields: React.FC<
  AddCompanySiteFormFieldsPropsType
> = ({ onClose }) => {
  const { t } = useTranslation('companyDetailsGeneral');

  return (
    <Stack gap="xl">
      <AddressFields.Root>
        <AddressFields.Street />
        <AddressFields.Addition />
        <AddressFields.Zip />
        <AddressFields.City />
        <AddressFields.Country />
      </AddressFields.Root>
      <ContactFields.Root>
        <ContactFields.Phone />
        <ContactFields.Email />
        <ContactFields.Fax />
      </ContactFields.Root>
      <FormActions
        onCancel={onClose}
        saveButtonText={t('SAVE_BUTTON', { ns: 'common' })}
        cancelButtonText={t('CANCEL_BUTTON', { ns: 'common' })}
      />
    </Stack>
  );
};
